const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const weekdayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const fetchJSON = (url, config = {}) => {
  return fetch(url, Object.assign({}, getDefaultRequestConfig(), config)).then(response => {
    if (!response.ok) {
      throw response
    }
    return response.json()
  })
}
window.fetchJSON = fetchJSON
// for fetch product data
const fetchProductData = async (handle) => {  
  try {
    const [data, metafields] = await Promise.all([
      fetchJSON(`/products/${handle}.js`),
      fetchProductMetafieldData(handle),
    ])
    return {
      ...data,
      metafields,
    }
  } catch (e) {
    console.error(e)
  }
}
const fetchProductMetafieldData = (handle) => {
  try {
    return fetchJSON(`/products/${handle}?view=json`, {
      method: 'GET',
    })
  } catch (e) {
    console.error(e)
  }
}

function resolveAvailableLeadtime (productDataMetafields) {
    const raw = productDataMetafields && productDataMetafields.available_leadtime
    if (raw != null && String(raw).trim() !== '') {
      return String(raw).trim()
    }
    return '1-3 days'
}

function getProductLeadTime (productDataMetafields, quantity) {
    const rawDate = productDataMetafields.available_date
    const hasRealDate = rawDate != null && String(rawDate).trim() !== '' && String(rawDate).trim().toLowerCase() !== 'now'
    const currentDate = hasRealDate ? new Date(rawDate) : new Date()
  
    if (productDataMetafields.inventory_quantity >= quantity) {
      const available_leadtime = resolveAvailableLeadtime(productDataMetafields)
      let msg1 = `Delivery available in ${available_leadtime}`;
      if(available_leadtime === '1-3 days') msg1 = `In stock & ready for delivery`;
      return {
        date: currentDate,
        message: msg1,
        shortMessage: msg1,
      }
    }
  
    if (!productDataMetafields.product_availability) return
    if (productDataMetafields.product_availability.length == 0) return
    
    const availabilityJson = productDataMetafields.product_availability
  
    let totalAvailable = productDataMetafields.inventory_quantity
    const nextAvailable = availabilityJson.find(productAvailability => {
      totalAvailable += parseInt(productAvailability.quantity)
      return totalAvailable >= quantity
    })
    return { 
      date: new Date(nextAvailable.date),
      message: `Delivery available in ${nextAvailable.leadtime}`,
      shortMessage: `Delivery available in ${nextAvailable.leadtime}`,
    }
}
function parseLeadTime (leadTimeObject) {
    const expectedMonth = leadTimeObject?.date ? monthNames[leadTimeObject.date.getMonth()] : monthNames[new Date().getMonth()]
    if (!leadTimeObject) {
      return {
        days: 0,
        weeks: 0,
        longMessage: `In stock & ready for delivery`,
        shortMessage: `In stock & ready for delivery`,
        expectedMonth,
      }
    }
  
    const leadTime = leadTimeObject.date
    const currentDate = new Date()
    const leadTimeTime = leadTime instanceof Date && !Number.isNaN(leadTime.valueOf()) ? leadTime.valueOf() : NaN
    const diff = Number.isNaN(leadTimeTime)
      ? NaN
      : Math.ceil((leadTimeTime - currentDate.valueOf()) / 86400000)

    const objectMessage = leadTimeObject.shortMessage || leadTimeObject.message || ''
    const objectHasWeekRange = Boolean(parseWeekRangeUpperBound(objectMessage))

    // Near-term / available_date "now": keep metafield lead-time copy
    // (e.g. drop-ship "7-10 days", or "In stock & ready for delivery").
    // Previously hardcoded "1-3 days" here and overwrote correct stock_info /
    // lead_time_override_short values for in-stock drop-ship SKUs.
    if (!Number.isNaN(diff) && diff <= 1 && !objectHasWeekRange) {
      const message = objectMessage || 'Delivery available in 1-3 days'
      return {
        weeks: 0,
        hideInfo: false,
        longMessage: message,
        shortMessage: message,
        expectedMonth,
      }
    }
  
    const weeks = Number.isNaN(diff) ? 0 : Math.ceil(diff / 7)
    const leadTimeWeeks = !Number.isNaN(diff) && diff > 14 ? weeks : 2

    let result
    if (leadTimeObject.message) {
      result = {
        weeks,
        hideInfo: true,
        longMessage: leadTimeObject.message,
        shortMessage: leadTimeObject.shortMessage,
        expectedMonth,
      }
    } else {
      result = {
        weeks,
        hideInfo: false,
        longMessage: `Delivery available in ${leadTimeWeeks}-${leadTimeWeeks + 2} weeks`,
        shortMessage: `Delivery available in ${leadTimeWeeks}-${leadTimeWeeks + 2} weeks`,
        expectedMonth,
      }
    }

    return {
      ...result,
      ...buildEstimatedDeliveryFields(result.shortMessage || result.longMessage),
    }
}

/**
 * A/B: weeks → "Estimated delivery in early|mid|late {Month}".
 * Uses the upper bound of the week window from today, then splits the target month into thirds.
 */
function parseWeekRangeUpperBound(message) {
  const normalized = String(message || '').toLowerCase()
  const rangeMatch = normalized.match(/(\d+)\s*-\s*(\d+)\s*weeks?/)
  if (rangeMatch) {
    return Math.max(parseInt(rangeMatch[1], 10), parseInt(rangeMatch[2], 10))
  }
  const singleMatch = normalized.match(/(\d+)\s*weeks?/)
  if (singleMatch) return parseInt(singleMatch[1], 10)
  return null
}

function getMonthPeriod(date) {
  const day = date.getDate()
  const daysInMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  const third = Math.floor(daysInMonth / 3) || 1
  if (day <= third) return 'early'
  if (day <= third * 2) return 'mid'
  return 'late'
}

function buildEstimatedDeliveryFields(message) {
  const weeks = parseWeekRangeUpperBound(message)
  if (!weeks) return {}

  const targetDate = new Date()
  targetDate.setHours(0, 0, 0, 0)
  targetDate.setDate(targetDate.getDate() + weeks * 7)

  const estimatedPeriod = getMonthPeriod(targetDate)
  const estimatedMonth = monthNames[targetDate.getMonth()]

  return {
    estimatedPeriod,
    estimatedMonth,
    estimatedDeliveryMessage: `Estimated delivery in ${estimatedPeriod} ${estimatedMonth}`,
  }
}

const updateDeliveryTooltipMonth = (deliveryMessageElement, leadTimeMessage) => {
  if (!deliveryMessageElement || !leadTimeMessage) return
  const deliveryContainer = deliveryMessageElement.closest('.prd-ProductOffers_Delivery')
  if (!deliveryContainer) return
  const monthEl = deliveryContainer.querySelector('.js-Delivery_ExpectedMonth')
  if (!monthEl) return

  // Prefer weeks→month A/B estimate so tooltip matches `.prd-Delivery_Estimate`.
  if (leadTimeMessage.estimatedPeriod && leadTimeMessage.estimatedMonth) {
    monthEl.textContent = `${leadTimeMessage.estimatedPeriod} ${leadTimeMessage.estimatedMonth}`
    return
  }

  if (leadTimeMessage.estimatedMonth) {
    monthEl.textContent = leadTimeMessage.estimatedMonth
    return
  }

  // Derive from visible weeks copy when sync runs without estimate fields.
  const source =
    leadTimeMessage.shortMessage ||
    leadTimeMessage.longMessage ||
    deliveryMessageElement.textContent
  const derived = buildEstimatedDeliveryFields(source)
  if (derived.estimatedPeriod && derived.estimatedMonth) {
    monthEl.textContent = `${derived.estimatedPeriod} ${derived.estimatedMonth}`
    return
  }

  monthEl.textContent = leadTimeMessage.expectedMonth || monthNames[new Date().getMonth()]
}
window.updateDeliveryTooltipMonth = updateDeliveryTooltipMonth

const hasLeadTimeMessage = (message = '') => {
  const normalizedMessage = String(message).replace(/\s+/g, ' ').trim().toLowerCase()
  if (!normalizedMessage) return false
  if (normalizedMessage.includes('in stock & ready for delivery')) return false
  return (
    normalizedMessage.includes('delivery available in') ||
    normalizedMessage.includes('estimated delivery in')
  )
}

const updateDeliveryStockNote = (deliveryMessageElement, productDataMetafields) => {
  if (!deliveryMessageElement) return
  const deliveryContainer = deliveryMessageElement.closest('.prd-ProductOffers_Delivery')
  if (!deliveryContainer || deliveryContainer.dataset.stockNoteEnabled !== 'true') return

  const note = deliveryContainer.querySelector('.prd-Delivery_StockNote')
  if (!note) return

  const inventoryQuantity = Number(productDataMetafields?.inventory_quantity || 0)
  note.textContent = ''

  if (inventoryQuantity <= 0) {
    note.hidden = true
    return
  }

  const strong = document.createElement('strong')
  strong.textContent = inventoryQuantity <= 5
    ? `Low stock, only ${inventoryQuantity} left`
    : 'Limited availability'

  note.append(' - ', strong)
  note.hidden = false
}

/**
 * Fill A/B estimated-month copy. Kept hidden by CSS for Intelligems control;
 * variant CSS should show [data-has-estimate="true"] and hide [data-ab-delivery-control].
 *
 * Falls back to parsing the visible control text so a later syncAllDeliveryLeadTimeUI()
 * call (window load, no leadTimeMessage) cannot wipe a weeks-based estimate.
 */
function syncDeliveryEstimateUI(deliveryMessageElement, leadTimeMessage) {
  if (!deliveryMessageElement) return
  const deliveryContainer = deliveryMessageElement.closest('.prd-ProductOffers_Delivery')
  const estimateEl = deliveryContainer && deliveryContainer.querySelector('[data-ab-delivery-estimate]')
  if (!estimateEl) return

  let estimatedMessage = leadTimeMessage && leadTimeMessage.estimatedDeliveryMessage
  if (!estimatedMessage) {
    const source =
      (leadTimeMessage && (leadTimeMessage.shortMessage || leadTimeMessage.longMessage)) ||
      deliveryMessageElement.textContent
    estimatedMessage = buildEstimatedDeliveryFields(source).estimatedDeliveryMessage
  }

  if (estimatedMessage) {
    estimateEl.textContent = estimatedMessage
    estimateEl.setAttribute('data-has-estimate', 'true')
  } else {
    estimateEl.textContent = ''
    estimateEl.removeAttribute('data-has-estimate')
  }
}

const syncDeliveryLeadTimeUI = (deliveryMessageElement, leadTimeMessage) => {
  if (!deliveryMessageElement) return
  const deliveryContainer = deliveryMessageElement.closest('.prd-ProductOffers_Delivery')
  if (!deliveryContainer) return

  const infoContainer = deliveryContainer.querySelector('.prd-Delivery_InfoTooltipContainer')
  const shortMessage = leadTimeMessage && leadTimeMessage.shortMessage ? leadTimeMessage.shortMessage : deliveryMessageElement.textContent
  const showLeadTimeInfo = hasLeadTimeMessage(shortMessage) || Boolean(leadTimeMessage?.estimatedDeliveryMessage)

  if (infoContainer) infoContainer.hidden = !showLeadTimeInfo
  syncDeliveryEstimateUI(deliveryMessageElement, leadTimeMessage)
  updateDeliveryTooltipMonth(
    deliveryMessageElement,
    leadTimeMessage || { shortMessage: deliveryMessageElement.textContent }
  )
}

/** Lead times that are not pre-order (standard / near-term delivery). */
const STANDARD_DELIVERY_LEAD_TIMES = ['1-3 days', '7-10 days']

function isStandardDeliveryLeadTime(leadtime) {
  const normalized = String(leadtime || '').toLowerCase().trim()
  return STANDARD_DELIVERY_LEAD_TIMES.includes(normalized)
}

function isPreOrderLeadTime(productDataMetafields, quantity) {
  if (!productDataMetafields) return false

  const inventoryQuantity = parseInt(productDataMetafields.inventory_quantity, 10) || 0
  const availableLeadtime = resolveAvailableLeadtime(productDataMetafields).toLowerCase()

  // Show pre-order only when lead time is longer than "7-10 days"
  if (inventoryQuantity >= quantity && isStandardDeliveryLeadTime(availableLeadtime)) {
    return false
  }

  const leadTime = getProductLeadTime(productDataMetafields, quantity)
  if (!leadTime || !leadTime.message) return false

  const message = String(leadTime.message).toLowerCase()
  if (message.includes('in stock') && message.includes('ready for delivery')) {
    return false
  }
  if (STANDARD_DELIVERY_LEAD_TIMES.some((lead) => message.includes(lead))) {
    return false
  }

  return true
}

function syncPreOrderTag(deliveryMessageElement, productDataMetafields, quantity) {
  if (!deliveryMessageElement) return

  const container = deliveryMessageElement.closest('.prd-ProductOffers_Delivery')
  const tag = container && container.querySelector('[data-ab-pre-order-tag]')
  if (!tag) return

  const showTag = isPreOrderLeadTime(productDataMetafields, quantity)
  if (showTag) {
    tag.removeAttribute('hidden')
  } else {
    tag.setAttribute('hidden', '')
  }
}

window.hasLeadTimeMessage = hasLeadTimeMessage
window.updateDeliveryStockNote = updateDeliveryStockNote
window.syncDeliveryLeadTimeUI = syncDeliveryLeadTimeUI
window.syncDeliveryEstimateUI = syncDeliveryEstimateUI
window.isPreOrderLeadTime = isPreOrderLeadTime
window.syncPreOrderTag = syncPreOrderTag
window.buildEstimatedDeliveryFields = buildEstimatedDeliveryFields

const syncAllDeliveryLeadTimeUI = () => {
  const deliveryEls = document.querySelectorAll('.prd-ProductOffers_Delivery .js-Product_Delivery')
  for (const deliveryEl of deliveryEls) {
    syncDeliveryLeadTimeUI(deliveryEl)
  }
}

window.syncAllDeliveryLeadTimeUI = syncAllDeliveryLeadTimeUI

if (document.readyState === 'complete') {
  syncAllDeliveryLeadTimeUI()
} else {
  window.addEventListener('load', syncAllDeliveryLeadTimeUI, { once: true })
}

function getLongestLeadTime (leadTimes) {
    leadTimes.sort((a, b) => {
      return b.date.valueOf() - a.date.valueOf()
    })
  
    return leadTimes[0]
}
function addDays (date, days) {
    const result = new Date(date)
    result.setDate(result.getDate() + days)
    return result
}
async function getCartMaxQuantities () {
    const leadTimeObject = await fetchJSON(`/cart?view=lead-time`)
    return parseLeadTimeObject(leadTimeObject);
}
const productMaxQuantityFetchSeq = {}

function clearProductMaxQuantityCache () {
  if (!window.theme) window.theme = {}
  window.theme.productMaxQuantities = {}
  Object.keys(productMaxQuantityFetchSeq).forEach((key) => {
    productMaxQuantityFetchSeq[key] = (productMaxQuantityFetchSeq[key] || 0) + 1
  })
}
window.clearProductMaxQuantityCache = clearProductMaxQuantityCache

function invalidateProductMaxQuantityCache (variantId) {
  const key = String(variantId || '')
  if (key && window.theme?.productMaxQuantities) {
    delete window.theme.productMaxQuantities[key]
  }
  if (key) {
    productMaxQuantityFetchSeq[key] = (productMaxQuantityFetchSeq[key] || 0) + 1
  }
}
window.invalidateProductMaxQuantityCache = invalidateProductMaxQuantityCache

async function getProductMaxQuantity (productUrl, variantId) {
    const variantKey = String(variantId || '')
    const seq = (productMaxQuantityFetchSeq[variantKey] = (productMaxQuantityFetchSeq[variantKey] || 0) + 1)
    let fetchUrl = productUrl || '';
    try {
      const url = new URL(fetchUrl, window.location.origin);
      url.searchParams.set('view', 'lead-time');
      const variant = variantId || url.searchParams.get('variant');
      if (variant) url.searchParams.set('variant', variant);
      fetchUrl = `${url.pathname}${url.search}`;
    } catch (e) {
      const join = fetchUrl.indexOf('?') > -1 ? '&' : '?';
      fetchUrl = `${fetchUrl}${join}view=lead-time`;
      if (variantId && fetchUrl.indexOf('variant=') === -1) {
        fetchUrl += `&variant=${variantId}`;
      }
    }
    const leadTimeObject = await fetchJSON(fetchUrl);
    if (variantKey && seq !== productMaxQuantityFetchSeq[variantKey]) {
      return window.theme.productMaxQuantities || {}
    }
    return parseLeadTimeObject(leadTimeObject);
}

function parseLeadTimeObject(leadTimeObject) {
  if (!leadTimeObject) {
      return;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tenWeeks = new Date();
  const leadTimeMaxDays = parseInt(window.theme?.leadTimeMaxDays, 10) || 70;
  tenWeeks.setDate(tenWeeks.getDate() + leadTimeMaxDays);

  const parsedItems = {};

  for (const product in leadTimeObject) {
      if (leadTimeObject.hasOwnProperty(product)) {
          const productLeadTime = leadTimeObject[product];
          const { available, availability, cart } = productLeadTime;
          const availabilityRows = Array.isArray(availability) ? availability : [];
          const availableQty = Number(available) || 0;

          const fromRows = availabilityRows.reduce((total, delivery) => {
              const deliveryDate = new Date(delivery.date);
              if (deliveryDate > tenWeeks || deliveryDate < today) {
                  return total;
              }
              const rowQty = parseInt(delivery.quantity, 10);
              return total + (Number.isFinite(rowQty) ? rowQty : 0);
          }, 0);

          const totalAvailable = fromRows + availableQty;

          const cartQty = Number(cart) || 0;
          const max = Math.max(0, totalAvailable - cartQty);

          parsedItems[product] = { ...productLeadTime, cart: cartQty, totalAvailable, max };
      }
  }

  const current = window.theme.productMaxQuantities || {};
  window.theme.productMaxQuantities = { ...current, ...parsedItems };
  return window.theme.productMaxQuantities;
}

const getCartStockScarcityMessage = (productDataMetafields) => {
  if (!productDataMetafields) return null
  return productDataMetafields.low_stock_message || null
}

const updateCartItemStockScarcity = (cartItemKey, productDataMetafields) => {
  if (!productDataMetafields) return

  const message = getCartStockScarcityMessage(productDataMetafields)
  const els = getElements(`.cart-item[data-key="${cartItemKey}"] .ig-CartStockScarcity`)

  if (!message) {
    els.forEach((el) => el.remove())
    return
  }

  if (els.length === 0) {
    const details = document.querySelector(`.cart-item[data-key="${cartItemKey}"] .cart-item__details`)
    const anchor = details?.querySelector('.psh-Item_LightingDelivery')
    if (details && anchor) {
      const el = document.createElement('p')
      el.className = 'psh-Item_StockScarcity ig-CartStockScarcity body_default regular margin-top-0 margin-bottom-4'
      el.textContent = message
      anchor.insertAdjacentElement('afterend', el)
    }
    return
  }

  els.forEach((el) => {
    el.textContent = message
    el.hidden = false
  })
}

window.getCartStockScarcityMessage = getCartStockScarcityMessage
window.updateCartItemStockScarcity = updateCartItemStockScarcity

async function syncCartQuantityStockLimits () {
  if (!window.theme) window.theme = {}
  if (!window.theme.productMaxQuantities || Object.keys(window.theme.productMaxQuantities).length === 0) {
    await getCartMaxQuantities()
  }
  const quantities = window.theme.productMaxQuantities || {}
  document.querySelectorAll('quantity-input.cart-quantity').forEach((el) => {
    if (el.dataset.unlimitedQty === 'true') return
    if (typeof el.validateQtyRules === 'function') {
      el.validateQtyRules('', quantities, '')
    }
  })
}
window.syncCartQuantityStockLimits = syncCartQuantityStockLimits

async function refreshPdpQuantityStockLimits () {
  resetPdpStockUiState()
  const tasks = []

  document.querySelectorAll('quantity-input.quantity:not(.cart-quantity)').forEach((el) => {
    if (el.dataset.unlimitedQty === 'true') return
    if (typeof el.refreshStockLimits === 'function') {
      tasks.push(el.refreshStockLimits())
    }
  })

  document.querySelectorAll('product-form').forEach((form) => {
    if (typeof form.isMainBuyForm !== 'function' || !form.isMainBuyForm()) return
    if (typeof form.syncStockLimitState === 'function') {
      tasks.push(form.syncStockLimitState())
    }
  })

  await Promise.all(tasks)
}
window.refreshPdpQuantityStockLimits = refreshPdpQuantityStockLimits

function getPdpMainQuantityContext () {
  const pdpQuantityInput = document.querySelector('.quantity_selector-buy_buttons quantity-input')
  if (!pdpQuantityInput) return null

  const pdpVariantId = pdpQuantityInput.getAttribute('data-id')
  const input = pdpQuantityInput.querySelector('.quantity__input')
  if (!pdpVariantId || !input) return null

  const productInfo = document.querySelector('product-info:not([data-original-section])')
  return { pdpVariantId, input, productInfo, pdpQuantityInput }
}

function getCartQuantityForVariant (variantId, cartData) {
  let cartQty = 0
  if (!variantId || !cartData?.items?.length) return cartQty

  cartData.items.forEach((item) => {
    if (String(item.variant_id) === String(variantId)) {
      cartQty += parseInt(item.quantity, 10) || 0
    }
  })
  return cartQty
}
window.getCartQuantityForVariant = getCartQuantityForVariant

function syncPdpCartQuantityForVariant (variantId, cartData) {
  const context = getPdpMainQuantityContext()
  if (!context) return

  const resolvedVariantId = variantId || context.pdpVariantId
  if (String(context.pdpVariantId) !== String(resolvedVariantId)) return

  const cartQty = getCartQuantityForVariant(resolvedVariantId, cartData)
  context.input.setAttribute('data-cart-quantity', String(cartQty))

  if (context.productInfo?.input) {
    context.productInfo.input.setAttribute('data-cart-quantity', String(cartQty))
    if (typeof context.productInfo.setQuantityBoundries === 'function') {
      context.productInfo.setQuantityBoundries()
    }
  }
}
window.syncPdpCartQuantityForVariant = syncPdpCartQuantityForVariant

function releasePdpStockAfterCartRemove (variantId, cartData) {
  const context = getPdpMainQuantityContext()
  if (!context) return

  const resolvedVariantId = variantId || context.pdpVariantId
  if (String(context.pdpVariantId) !== String(resolvedVariantId)) return

  syncPdpCartQuantityForVariant(resolvedVariantId, cartData)

  if (typeof resetPdpStockUiState === 'function') {
    resetPdpStockUiState()
  }

  if (typeof invalidateProductMaxQuantityCache === 'function') {
    invalidateProductMaxQuantityCache(resolvedVariantId)
  } else if (window.theme?.productMaxQuantities) {
    delete window.theme.productMaxQuantities[resolvedVariantId]
  }
}
window.releasePdpStockAfterCartRemove = releasePdpStockAfterCartRemove

function resetPdpStockUiState () {
  document.querySelectorAll('quantity-input.quantity:not(.cart-quantity)').forEach((el) => {
    el.stockLimits = undefined
    if (typeof el.setMaxQtyErrorVisible === 'function') el.setMaxQtyErrorVisible(false)
    if (typeof el.setPlusDisabled === 'function') el.setPlusDisabled(false)

    const input = el.querySelector('.quantity__input')
    const min = parseInt(input?.min || input?.dataset?.min || '1', 10)
    const value = parseInt(input?.value, 10) || min
    const minus = el.querySelector(".quantity__button[name='minus']")
    if (minus) {
      const atMin = value <= min
      minus.classList.toggle('disabled', atMin)
      if (atMin) minus.setAttribute('disabled', '')
      else minus.removeAttribute('disabled')
    }
  })

  document.querySelectorAll('product-form').forEach((form) => {
    if (typeof form.isMainBuyForm !== 'function' || !form.isMainBuyForm()) return
    if (typeof form.setAtcStockDisabled === 'function') form.setAtcStockDisabled(false)
  })
}
window.resetPdpStockUiState = resetPdpStockUiState

const updateProductLeadTime = (key, leadtime, id, leadtime2, leadTimeMessage, productDataMetafields) => {
  const els = getElements(`.cart-item[data-key="${key}"] .psh-Item_LightingDelivery`)
  els.forEach((el) => {
    if (!el) return
    const next = leadtime == null ? '' : String(leadtime)
    if (el.textContent.trim() !== next.trim()) el.textContent = next
  })
  const proEls = getElement(`.prd-ProductOffers_Delivery[data-id="${id}"] .js-Product_Delivery`)
  if (proEls) {
    proEls.innerHTML = leadtime2
    updateDeliveryTooltipMonth(proEls, leadTimeMessage)
    syncDeliveryLeadTimeUI(proEls, leadTimeMessage)
  }
  updateCartItemStockScarcity(key, productDataMetafields)
}

/** Snapshot cart-line delivery copy before section HTML replace (avoids empty→fill flicker). */
const snapshotCartLineDeliveryMessages = () => {
  const cache = {}
  document.querySelectorAll('.cart-item[data-key]').forEach((item) => {
    const key = item.getAttribute('data-key')
    const el = item.querySelector('.psh-Item_LightingDelivery')
    const text = el?.textContent?.trim()
    if (key && text) cache[key] = text
  })
  return cache
}

const restoreCartLineDeliveryMessages = (cache) => {
  if (!cache) return
  Object.keys(cache).forEach((key) => {
    const text = cache[key]
    document.querySelectorAll(`.cart-item[data-key="${key}"] .psh-Item_LightingDelivery`).forEach((el) => {
      if (el && !el.textContent.trim()) el.textContent = text
    })
  })
}

window.snapshotCartLineDeliveryMessages = snapshotCartLineDeliveryMessages
window.restoreCartLineDeliveryMessages = restoreCartLineDeliveryMessages

let updateCartLeadTimeTimer = null
let updateCartLeadTimeGeneration = 0

const updateCartLeadTimeImpl = async (data) => {
  if (!data?.items?.length) return
  const generation = ++updateCartLeadTimeGeneration

  for (const item of data.items) {
    if (item.product_type == 'Disposal' || item.product_type == 'Swatch') continue
    if (generation !== updateCartLeadTimeGeneration) return

    let currentMaxQuantities = window.theme.productMaxQuantities
    if (!currentMaxQuantities || Object.keys(currentMaxQuantities).length === 0) {
      currentMaxQuantities = await getProductMaxQuantity(item.url, item.id)
    }
    if (generation !== updateCartLeadTimeGeneration) return
    if (currentMaxQuantities[item.id] === null) {
      currentMaxQuantities = await getProductMaxQuantity(item.url, item.id)
    }
    if (generation !== updateCartLeadTimeGeneration) return

    const productData = await fetchProductData(item.handle)
    if (generation !== updateCartLeadTimeGeneration) return
    if (!productData?.metafields) continue

    let qtyValue = parseInt(item.quantity, 10) + (productData.metafields.quantity_in_product ? productData.metafields.quantity_in_product : 1)
    const stock = currentMaxQuantities[item.id]
    if (stock != undefined && (stock.totalAvailable <= item.quantity || qtyValue > stock.totalAvailable)) {
      qtyValue = stock.totalAvailable
    }

    const leadtime = parseLeadTime(getProductLeadTime(productData.metafields, item.quantity)).shortMessage
    const leadtime2 = parseLeadTime(getProductLeadTime(productData.metafields, qtyValue))
    updateProductLeadTime(item.key, leadtime, item.id, leadtime2.shortMessage, leadtime2, productData.metafields)
  }
}

const updateCartLeadTime = (data) => {
  if (updateCartLeadTimeTimer) clearTimeout(updateCartLeadTimeTimer)
  updateCartLeadTimeTimer = setTimeout(() => {
    updateCartLeadTimeTimer = null
    updateCartLeadTimeImpl(data)
  }, 150)
}